/* eslint-disable quote-props */
export default {
    'ok': 'Ok',
    'Search': 'Suche',
    'Address': 'Adresse',
    'Routing': 'Routing',
    'From here': 'Von',
    'Waypoint here': 'Routenwegpunkt',
    'Destination here': 'Nach',
    'Distance': 'Entfernung',
    'Line': 'Linie',
    'Road': 'Straße',
    'Area': 'Bereich',
    'fullScreen': 'Ganzer bildschirm',
    'gasStation': 'Tankstelle',
    'gasstations': 'Tankstellen',
    'naturalgasstations': 'Gasstationen',
    'electricchargers': 'Elektro-Ladestationen',
    'detailedLocation': 'Detaillierte Lage',
    'street': 'Straße',
    'city': 'Ort',
    'postalCode': 'Postleitzahl',
    'municipality': 'Gemeinde',
    'regionLevel2': 'Provinz',
    'regionLevel1': 'Region',
    'country': 'Land',
    'altitude': 'Hoogte',
    'xy': 'Y,X',
    'maximumSpeed': 'Maximale geschwindigkeit',
    'copy': 'Kopieren',
    'go': 'Gehen',
    'call': 'Anruf',
    'send:': 'Senden',
    'calculateIsochrone': 'Isochrone berechnen',
    'car': 'Auto',
    'bicycle': 'Fahrrad',
    'onFoot': 'Zu Fuß',
    'simplified': 'Vereinfacht',
    'detailed': 'Detaillierte',
    'starting': 'Von',
    'arrival': 'Nach',
    'increments': 'Schritte',
    'maxWeight': 'Maximales gewicht',
    'maxAxleWeight': 'Maximales achsgewicht',
    'maxHeight': 'Maximale höhe',
    'maxLength': 'Maximale länge',
    'maxWidth': 'Maximale breite',
    'maxSpeed': 'Maximale geschwindigkeit',
    'showRoadRestrictions': 'Straßenbeschränkungen anzeigen',
    'temporalRestrictions': 'Befristete Beschränkungen',
    'startTime': 'Startzeit',
    'endTime': 'Endzeit',
    'dangerousGoods': 'Gefahrgut',
    'trc': 'Tunnelbeschränkungscode',
    'trucks': 'Lastwagen',
    'morning': 'Morgen',
    'afternoon': 'Nachmittag',
    'price': 'Preis',
    'schedule': 'Zeitplan',
    'font': 'Brunnen',
    'liveTraffic': 'Live-Verkehr',
    'forecastTraffic': 'Prognoseverkehr',
    'slow': 'Langsam',
    'fast': 'Schnell',
    'roadWorks': 'Straßenarbeiten',
    'AbnormalTraffic': 'Abnormaler Verkehr',
    'queueingTraffic': 'Stauender Verkehr',
    'slowTraffic': 'Langsamer Verkehr',
    'stationaryTraffic': 'Stehender Verkehr',
    'Accident': 'Unfall',
    'accident': 'Unfall',
    'EnvironmentalObstruction': 'Umweltbedingte Behinderung',
    'flooding': 'Überschwemmung',
    'landslips': 'Erdrutsche',
    'rockfalls': 'Steinschläge',
    'GeneralObstruction': 'Allgemeine Behinderung',
    'incident': 'Vorfall',
    'objectOnTheRoad': 'Gegenstand auf der Straße',
    'obstructionOnTheRoad': 'Hindernis auf der Straße',
    'shedLoad': 'Verlorene Ladung',
    'MaintenanceWorks': 'Wartungsarbeiten',
    'maintenanceWork': 'Wartungsarbeit',
    'other': 'Andere',
    'resurfacingWork': 'Asphaltierungsarbeiten',
    'MaintenanceWorks roadworks': 'Wartungsarbeiten, Straßenarbeiten',
    'MaintenanceWorks roadworks, maintenanceWork': 'Wartungsarbeiten, Straßenarbeiten, Wartungsarbeit',
    'roadworks': 'Straßenarbeiten',
    'roadworks, maintenanceWork': 'Straßenarbeiten, Wartungsarbeit',
    'roadworks, maintenanceWork, resurfacingWork': 'Straßenarbeiten, Wartungsarbeit, Asphaltierungsarbeiten',
    'roadworks, resurfacingWork': 'Straßenarbeiten, Asphaltierungsarbeiten',
    'NetworkManagement': 'Netzwerkverwaltung',
    'contraflow': 'Gegenverkehr',
    'intermittentShortTermClosures': 'Kurzfristige Unterbrechungen',
    'laneOrCarriagewayClosed': 'Fahrspur oder Fahrbahn gesperrt',
    'narrowLanes': 'Schmale Fahrspuren',
    'restrictions': 'Einschränkungen',
    'roadClosed': 'Straße gesperrt',
    'singleAlternateLineTraffic': 'Wechselverkehr auf einer Spur',
    'VehicleObstruction': 'Fahrzeugbehinderung',
    'brokenDownVehicle': 'Pannenfahrzeug',
    'slowMovingMaintenanceVehicle': 'Langsam fahrendes Wartungsfahrzeug',
    'snowplough': 'Schneepflug',
    'vehicleOnFire': 'Fahrzeug in Flammen',
    'obstruction': 'Obstruktion',
    'monday': 'Montag',
    'tuesday': 'Dienstag',
    'wednesday': 'Mittwoch',
    'thursday': 'Donnerstag',
    'friday': 'Freitag',
    'saturday': 'Samstag',
    'sunday': 'Sonntag',
    'direction': 'Richtung',
    'mapCenter': 'Kartenmitte',
    'maxResults': 'Maximale Ergebnisse',
    'maxRadius': 'Maximaler radius',
    'viewOnMap': 'Ansicht auf Karte',
    'proximity': 'Nähe',
    'selectCategories': 'Kategorien auswählen',
    'minimizeRoutingMenu': 'Minimieren Sie das Routing-Menü',
    'closeRouteMenu': 'Schließen Sie das Routing-Menü',
    'writeOrClickMap': 'Schreiben Sie oder klicken Sie auf die Karte',
    'routeTo': 'Nach...',
    'waypoint': 'Routenwegpunkt ...',
    'addWaypoint': 'Wegpunkt hinzufügen',
    'cleanRoute': 'Route löschen',
    'saveRoute': 'Route speichern',
    'printRoute': 'Route drucken',
    'modifyRouteOptions': 'Routenoptionen ändern',
    'logisticsRoute': 'LKW-Routen',
    'routeType': 'Route Typ',
    'time': 'Zeit',
    'restTime': 'Ruhezeit',
    'distance': 'Distanz',
    'avoidTolls': 'Vermeiden Sie Straßengebühren',
    'realtime': 'Echtzeit',
    'optimizedRoute': 'Optimierte Route',
    'addedCosts': 'Zusätzliche Kosten',
    'departureTime': 'Abfahrtszeit',
    'moreDetails': 'Meer details',
    'withoutTraffic': 'zonder verkeer',
    'ofRest': 'van de rest (fahrtenschreiber)',
    'ZBEInfo': 'Informationen über diese emissionsarme Zone',
    'routeCar': 'Route met de auto',
    'routeTruck': 'Route per vrachtwagen',
    'hour': 'Stunde',
    'roadRestrictions': 'Straßenbeschränkungen',
    'addBreakTime': 'Pausenzeit hinzufügen (fahrtenschreiber)',
    'twoDrivers': 'Zwei fahrer',
    'refresh': 'Erquicken',
    'disabled': 'Deaktiviert',
    'sunLight': 'Zon verlichting',
    'neighborhoods': 'Nachbarschaften',
    'postalcodes': 'Postleitzahl',
    'municipalities': 'Gemeenten',
    'routeStopsFrom': 'From:',
    'routeStopsThrought': 'durch:',
    'routeStopsTo': 'nach:',
    'routeStopsTrafficDelay': 'Verkehrsverzögerung',
    'routeSummaryDetails': 'DETAILLIERTE ROUTE ',
    'routeSummaryTraficJam': 'stau',
    'searchAddress': 'Adresse',
    'searchPostalCode': 'Postleitzahl',
    'searchCoordinates': 'Koordinaten',
    'searchLocality': 'Ortschaft',
    'searchPOIs': 'POIs',
    'searchSearchBtn': 'Suche',
    'searchNearestAddress': 'Nächste Adresse',
    'searchSelectCountry': 'Land auswählen',
    'searchAllCountries': 'Alle Länder',
    'searchProjection': 'Projektion',
    'searchXCoordinate': 'X-Koordinate',
    'searchYCoordinate': 'Y-Koordinate',
    'searchCandidates': 'Kandidaten',
    'tooltipAdvancedSearch': 'Erweiterte suche',
    'tooltipRouting': 'Route berechnen',
    'tooltipPois': 'POIs',
    'tooltipMeteo': 'Wettervorhersage',
    'tooltipGasStations': 'Tankstellen',
    'tooltipTraffic': 'Der Verkehr',
    'tooltipZBE': 'Emissionsarme Zonen',
    'tooltipStreetView': 'Straßenansicht',
    'tooltipClean': 'Saubere Karte',
    'tooltipDraw': 'Tekenen',
    'tooltipLayerSwitcher': 'Kartentyp',
    'tooltipLayerRegion': 'Fügen Sie administrative Ebenen hinzu',
    'tooltipLogisticsRestrictions': 'Lkw-Straßenbeschränkungen',
    'tooltipIsochrones': 'Isochronen berechnen',
    'tooltipBuildings3D': 'Bekijk gebouwen in 3D-weergave',
    'rainRadar': 'Regenradar',
    'notificationRouteCantGetPosition': 'Kann deine aktuelle Position nicht bekommen. Bitte Ursprung Richtung eingeben.',
    'notificationErrorSavingKML': 'Fehler beim Speichern von KML.',
    'notificationErrorGetPostalCode': 'Kann keine Postleitzahl erhalten. Fehler: ',
    'notificationControlAlreadyExists': 'Kontrolle existiert bereits:',
    'notificationSelectCategories': 'Zuerst die Kategorien auswählen',
    'notificationPoisNotFound': 'POIs nicht gefunden',
    'notificationDrawIsochrone': 'Klicken Sie auf den Punkt der Karte, in der Sie die Isochrone berechnen möchten',
    'notificationErrorGetPathRouting': 'Der Weg der Route konnte nicht gefunden werden, überprüfen Sie die Kreuzungspunkte.',
    'assertMapNotDefined': 'Map not defined',
    'assertFeatureExists': 'Feature already exists',
    'assertUnknownBaseLayer': 'Unknown setBaseLayer: ',
    'assertLayerNotSpecified': 'Layer not specified',
    'asserInvalidObjectLonLat': 'Not a \'cercalia.LonLat\' type object',
    'assertUknownWeight': 'Uknown weight: ',
    'assertParameterIsNotFunction': 'Parameter is not a callback function',
    'assertUknownParameter': 'Uknown parameter: ',
    'assertOriginInvalid': 'Can\'t calculate route. Invalid origin: ',
    'assertStepInvalid': 'Can\'t calculate route. Invalid step: ',
    'assertDestinationInvalid': 'Can\'t calculate route. Invalid destination: ',
    'assertProjectionNotDefined': 'Layer projection not declared: ',
    'assertGpsNotPosition': 'Can\'t get GPS position.',
};
//# sourceMappingURL=de.js.map